import React, { useState, useRef, useEffect } from "react"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import { useCarnetAdresse } from "./map-carnet-adresse-query"
import LeafletMap from "gatsby-theme-blank/src/components/Map/leafletmap"
import Leaflet from "leaflet"
import { Marker, Popup } from "react-leaflet"
import {
  container,
  infosContainer,
  mapContainer,
  filtersTaxo,
  popupInfos,
  listAddressesTitle,
  addressesDescription,
  allAdresses,
  leafletMapHidden,
  hideMap,
  adressesContainer,
  adressesContainerHidden,
  editButtonTitle,
  markerCluster,
} from "./map-carnet-adresse.module.scss"
import { Title } from "./map-carnet-adresse-styled"
import redMarker from "gatsby-theme-blank/src/components/Map/images/red-marker.png"
import { isDomAvailable } from "gatsby-theme-blank/src/components/Map/lib/util"
import { AdressItemTaxo } from "gatsby-theme-blank/src/templates/list/listItems/styled-components/adresse-item-styled"
import MarkerClusterGroup from "react-leaflet-markercluster"
import "leaflet/dist/leaflet.css"
import "react-leaflet-markercluster/dist/styles.min.css"
import { initialZoom } from "../../../constants"
import Obfuscate from "react-obfuscate"
import ContentTransformer from "../../Transformers/content-transformer"
import RenderAdresses from "./RenderAddresses/render-addresses"
import EditButton from "../../EditButton/edit-button"

const ChangeMapMarkers = (adresse, ref) => {
  useEffect(() => {
    const correspondingMarker = ref.current
      .filter(
        (element) =>
          element?.current?.props.position[0] ===
            adresse?.node.field_coordon?.lat &&
          element?.current?.props.position[1] ===
            adresse?.node.field_coordon?.lon
      )
      .shift()
    if (correspondingMarker !== undefined && adresse?.node.field_coordon) {
      correspondingMarker.current.leafletElement.openPopup()
    }
  })
}

//-----------------------Parent component---------------------------//

const CarnetAdresse = () => {
  /**
   * mapEffect
   * @description Fires a callback once the page renders
   * @example Here this is and example of being used to zoom in and set a popup on load
   */

  async function mapEffect({ leafletElement: map } = {}) {
    if (!map) return null
  }
  const data = useCarnetAdresse()
  let adresses = data.allNodeCarnetDAdresse.edges
  const allTaxo = []
  adresses.map(({ node }) => {
    const arrayTaxo = node.relationships.field_taxonomie_thematique
    allTaxo.push(
      ...arrayTaxo
        .map((element) => {
          return node.field_coordon ? element.name : null
        })
        .filter((element) => element)
    )
  })
  const uniqueTaxos = [...new Set(allTaxo)]
  const initialAdress = adresses
    .filter(({ node }) => node.field_coordon)
    .shift()
  const [choosenTaxo, setChoosenTaxo] = useState(null)
  const markerRef = useRef(
    [...new Array(adresses.length)].map(() => React.createRef())
  )
  const toggleTaxo = (taxoChoisie, nameTaxo) => {
    if (taxoChoisie === nameTaxo) {
      setChoosenTaxo(null)
    } else {
      setChoosenTaxo(nameTaxo)
    }
  }
  const [mapSettings, setMapSettings] = useState({
    center: [
      initialAdress?.node.field_coordon.lat ?? 46,
      initialAdress?.node.field_coordon.lon ?? 2,
    ],
    defaultBaseMap: "OpenStreetMap",
    zoom: initialZoom,
    mapEffect,
  })
  useEffect(() => {
    let choosenAdress
    if (choosenTaxo !== null) {
      choosenAdress = adresses[0]
    } else {
      choosenAdress = initialAdress
    }
    if (choosenAdress?.node?.field_coordon) {
      setMapSettings({
        center: [
          choosenAdress?.node.field_coordon.lat,
          choosenAdress?.node.field_coordon.lon,
        ],
        defaultBaseMap: "OpenStreetMap",
        zoom: initialZoom,
        mapEffect,
      })
    }
  }, [choosenTaxo, adresses, initialAdress])

  let customIcon = null
  if (isDomAvailable()) {
    customIcon = new Leaflet.Icon({
      iconUrl: redMarker,
      iconAnchor: [19, 15],
      iconSize: [35, 35],
    })
  }

  if (choosenTaxo !== null) {
    adresses = adresses.filter(({ node }) => {
      if (node.field_coordon) {
        for (
          let cpt = 0;
          cpt < node.relationships.field_taxonomie_thematique.length;
          cpt++
        ) {
          if (
            node.relationships.field_taxonomie_thematique[cpt].name ===
            choosenTaxo
          ) {
            return true
          }
        }
      }
      return false
    })
    ChangeMapMarkers(adresses[0], markerRef) // ChangeMapMarkers est placé ici et non pas dans le useEffect comme c'est le cas dans list/adresses. En effet, <MarkerClusterGroup> agit sur les popups de son côté -> J'ai déplacé useEffect dans le composant afin de surcharger ce comportement
  } else {
    ChangeMapMarkers(initialAdress, markerRef)
  }
  if (adresses.length === 0) {
    return null
  }
  const [isMapHidden, setIsMapHidden] = useState(true)
  return (
    <section className={container}>
      <button
        className={hideMap + " btn"}
        onClick={() => {
          setIsMapHidden(!isMapHidden)
        }}
        aria-expanded={!isMapHidden}
      >
        {isMapHidden ? " Afficher la liste des adresses" : " Afficher la carte"}
      </button>
      <div
        className={mapContainer + " " + (isMapHidden ? "" : leafletMapHidden)}
      >
        {/* leaftlet map */}
        <LeafletMap
          className={markerCluster}
          style={{ width: "100%", height: "100%" }}
          {...mapSettings}
        >
          <MarkerClusterGroup>
            {adresses.map(({ node }, key) => {
              const {
                drupal_id,
                title,
                field_coordon,
                field_adresse,
                field_mail,
                field_telephone,
              } = node
              if (!field_coordon) {
                return null
              }
              const position = [field_coordon.lat, field_coordon.lon]
              return (
                <Marker
                  ref={markerRef.current[key]}
                  key={drupal_id}
                  position={position}
                  icon={customIcon}
                >
                  <Popup className={popupInfos}>
                    <b>{title}</b>
                    <p>{field_adresse.address_line1}</p>
                    {field_adresse.address_line2 && (
                      <p>{field_adresse.address_line2}</p>
                    )}
                    <p>{field_adresse.postal_code}</p>
                    <p>{field_adresse.locality}</p>
                    <b>
                      <Obfuscate email={field_mail} />
                    </b>
                    <br />
                    <b>
                      <Obfuscate tel={field_telephone} />
                    </b>
                    <br />
                    <TransitionFade className="btn" link={node.path.alias}>
                      En savoir plus
                    </TransitionFade>
                  </Popup>
                </Marker>
              )
            })}
          </MarkerClusterGroup>
        </LeafletMap>
        <ul
          className={!isMapHidden ? adressesContainer : adressesContainerHidden}
        >
          <RenderAdresses addressesData={adresses} />
        </ul>
        <div className={infosContainer}>
          <Title className={listAddressesTitle}>
            <EditButton
              addedClass={editButtonTitle}
              link={
                "/taxonomy/term/" +
                data.taxonomyTermZoneDefinie.drupal_internal__tid +
                "/edit"
              }
            />
            {data.taxonomyTermZoneDefinie?.field_label || "Carnet d'addresses"}
          </Title>

          {data.taxonomyTermZoneDefinie.description && (
            <div className={addressesDescription}>
              <ContentTransformer
                content={data.taxonomyTermZoneDefinie.description.processed}
              ></ContentTransformer>
            </div>
          )}
          <div className={filtersTaxo}>
            {uniqueTaxos.slice(0, 6).map((element, key) => {
              let activeBool = false
              if (choosenTaxo === element) {
                activeBool = true
              }
              return (
                <AdressItemTaxo
                  onClick={() => {
                    toggleTaxo(choosenTaxo, element)
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      toggleTaxo(choosenTaxo, element)
                    }
                  }}
                  key={key}
                  aria-label={
                    activeBool
                      ? "Supprimer le filtre actif"
                      : "Filtrer sur la taxonomie '" + element + "'"
                  }
                  active={activeBool}
                >
                  {element}
                </AdressItemTaxo>
              )
            })}
          </div>
          <div className={allAdresses}>
            <TransitionFade className="btn" link="/adresses">
              Toutes les adresses
            </TransitionFade>
          </div>
        </div>
      </div>
    </section>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

//-----------------------Parent component---------------------------//

export default CarnetAdresse
